import VehicleLoginForm from "../../components/Forms/VehicleLoginForm";

const VehicleLogin = () => {
  return <VehicleLoginForm />;
};

export default VehicleLogin;
